import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import * as moment from "moment";
import { Observable, Subscription } from "rxjs";
import { filter, map, startWith, switchMap, tap } from "rxjs/operators";
import { InfoNascitaPFDTO } from "../../models/info-nascita-pf.dto";
import { NazioneDTO } from "../../models/nazione.dto";
import { Comune } from "../../models/portale/comune";
import { Localita } from "../../models/portale/localita";
import { Nazione } from "../../models/portale/nazione";
import { ComponentOutputStatus } from "../../normalizzazione/component-output-status";
import { MessageService } from "../../services/message.service";
import { TerritorioService } from "../../services/territorio/territorio-service";
import { ValidationService } from "../../services/validation.service";


@Component({
	selector: "lib-info-nascita",
	templateUrl: "./info-nascita.component.html",
	styleUrls: ["./info-nascita.component.css"],
})
export class InfoNascitaComponent implements OnInit, OnDestroy, OnChanges {

	maxDate = new Date();

	@Input()
	infonascita: InfoNascitaPFDTO;

	@Input()
	province: Observable<Array<Localita>>;

	@Input()
	namespace: string;

	@Input()
	readOnly: boolean = false;

	@Output()
	done: EventEmitter<
		ComponentOutputStatus<InfoNascitaPFDTO>
	> = new EventEmitter<ComponentOutputStatus<InfoNascitaPFDTO>>();

	form: FormGroup;
	subscription: Subscription;
	comuni$: Observable<Array<Comune>>;
	isNatoEstero$: Observable<boolean>;

	nazioni$: Observable<Array<Nazione>>;
	nazioni: Array<Nazione>;
	ITALIA = 'IT';
	ITALIACodCat = 'Z000';

	constructor(
		private msg: MessageService,
		private territorio: TerritorioService,
		private validationService: ValidationService,
		private territorioService: TerritorioService
	) {
		this.nazioni$ = territorioService.getNazioni$();
		this.nazioni$.subscribe(nazioni => {
			this.nazioni = nazioni;
		})
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.initialize();
	}

	ngOnInit() {
		// console.log('[InfoNascitaComponent] infonascita', this.infonascita);
		this.form = new FormGroup({});
		this.initialize();
		// const isNatoEstero =
		// 	this.infonascita.comuneNascita != null &&
		// 	this.infonascita.comuneNascita.startsWith("Z");
		const isNatoEstero = this.infonascita?.isNatoEstero ? this.infonascita.isNatoEstero : false;

		if (!isNatoEstero) {
			this.infonascita.nazioneNascita = this.ITALIA;
			this.infonascita.codCatNazioneNascita = this.ITALIACodCat;
		}

		const isNatoEsteroCheck = new FormControl(
			{ value: isNatoEstero, disabled: false },
			[Validators.required]
		);
		this.form.addControl("isNatoEstero", isNatoEsteroCheck);
			
		const provinciaNascita = new FormControl(
			{ value: this.infonascita.provinciaNascita, disabled: false },
			[Validators.required]
		);
		this.form.addControl("provinciaNascita", provinciaNascita);
		const comuneNascita = new FormControl(
			{ value: this.infonascita?.comuneNascita ? this.infonascita?.comuneNascita : this.ITALIACodCat, disabled: false },
			[Validators.required]
		);
		this.form.addControl("comuneNascita", comuneNascita);
		const dataNascita = new FormControl(
			{ value: this.infonascita.dataNascita, disabled: false },
			[Validators.required, ValidationService.ValidateDate]
		);
		this.form.addControl("dataNascita", dataNascita);

		const codCatNazioneNascita = new FormControl(
			{ value: this.infonascita.codCatNazioneNascita, disabled: false },
			[Validators.required]
		);
		this.form.addControl("codCatNazioneNascita", codCatNazioneNascita);


		if (this.readOnly) {
			this.form.disable();

			this.isNatoEstero$ = isNatoEsteroCheck.valueChanges.pipe(
				startWith(isNatoEstero)
			);
		} else {
			this.isNatoEstero$ = isNatoEsteroCheck.valueChanges.pipe(
				tap(isEstero => isEstero
					? codCatNazioneNascita.setValue(null)
					: (provinciaNascita.setValue(null), comuneNascita.setValue(null))
				),
				startWith(isNatoEstero),
				tap((isEstero) => {
					if (isEstero) {
						codCatNazioneNascita.enable();
						comuneNascita.disable();
						provinciaNascita.disable();
					} else {
						codCatNazioneNascita.disable();
						comuneNascita.enable();
						provinciaNascita.enable();
					}
				})
			);
		}
		const changes$ = this.form.valueChanges.pipe(
			map((_) => {
				const infonascita = new InfoNascitaPFDTO();
				infonascita.dataNascita = moment(this.form.controls["dataNascita"].value).toDate();
				if (this.form.controls["isNatoEstero"]?.value) {
					infonascita.isNatoEstero = this.form.controls["isNatoEstero"].value;
					//infonascita.comuneNascita = null;
					if(this.form.controls["codCatNazioneNascita"]?.value) {
						let nazioneSelected = this.nazioni.find(nazione => nazione.codiceCatastale == this.form.controls["codCatNazioneNascita"]?.value);
						if(nazioneSelected) {
							infonascita.codCatNazioneNascita = nazioneSelected.codiceCatastale;
							infonascita.nazioneNascita = nazioneSelected.sigla;
							infonascita.comuneNascita = nazioneSelected.codiceCatastale;
						}
					}
					infonascita.provinciaNascita = "EE";
				} else {
					infonascita.isNatoEstero = null;
					infonascita.comuneNascita = this.form.controls["comuneNascita"].value;
					infonascita.provinciaNascita = this.form.controls[
						"provinciaNascita"
					].value;
					infonascita.codCatNazioneNascita = this.ITALIACodCat;
					infonascita.nazioneNascita = this.ITALIA;
				}
				return infonascita;
			}),
			startWith(this.infonascita),
			map((infonascita) =>
				ComponentOutputStatus.of(
					this.form.valid || this.readOnly,
					infonascita
				)
			)
		);

		this.subscription = changes$.subscribe((_) => this.done.emit(_));

		this.comuni$ = provinciaNascita.valueChanges.pipe(
			tap(_ => comuneNascita.setValue(null) ),
			startWith(this.infonascita.provinciaNascita),
			filter((x) => x),
			switchMap((value) => this.territorio.getComuni$(value))
		);
	}

	private initialize() {
		if (!this.infonascita) {
			this.infonascita = this.initInfoNascita();
		}
	}

	initInfoNascita(): InfoNascitaPFDTO {
		const initInfoNascitaNew = new InfoNascitaPFDTO();
		return initInfoNascitaNew;
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	compareComuni(c1: Comune, c2: Comune) {
		return c1 && c2 ? c1.codiceCatastale === c2.codiceCatastale : c1 === c2;
	}

	public _resetForm() {
		this.form?.reset();
	}
}
